import { createAction, props } from "@ngrx/store";
import { estructuraBase, datosSolicitante, datosMadre, datosPadre,
   datosTutor, datosAval, referenciasFamiliares, referenciasPersonales,
    datosEscolaresLaborales, personasVivienda } from '../interfaces/solicitudes';

interface iSolicitudProgreso {
	Convocatoria_ID?:number,
	Curp?: string
}

export const creacionSolicitud = createAction(
	'[solicitud] creacion', props<{ solicitud: estructuraBase }>()
);


export const solicitante = createAction(
	'[solicitud] solicitante', props<{solicitante: datosSolicitante }>(),
);
export const padre = createAction(
	'[solicitud] padre', props<{padre: datosPadre }>()
);
export const madre = createAction(
	'[solicitud] madre', props<{madre: datosMadre }>()
);
export const tutor = createAction(
	'[solicitud] tutor', props<{tutor: datosTutor}>()
);
export const avales = createAction(
	'[solicitud] avales', props<{aval: datosAval}>()
);
export const personasViviendoJuntas = createAction(
	'[solicitud] personasVivienda', props<{personasVivienda: personasVivienda}>()
);
export const refFamiliares = createAction(
	'[solicitud] referenciasFamiliares', props<{referenciasFamiliares: referenciasFamiliares}>()
);
export const refPersonales = createAction(
	'[solicitud] referenciasPersonales', props<{referenciasPersonales: referenciasPersonales}>()
);
export const dtosEscolaresLaborales = createAction(
	'[solicitud] datosEscolaresLabolares', props<{datosEscolaresLaborales: datosEscolaresLaborales}>()
)

export const obtenerDatos = createAction(
	'[Solicitud] edicion de solicitud', props<{solicitud : any}> ()
)

export const obtenerErrores = createAction(
	'[error] obtenerErrores', props<{errores:any}>()
);
